import React from 'react';
import { Route, Switch } from 'react-router-dom';

import * as Subscription from './index';

export const routes = [
    {
        exact: true,
        path: '/events/:eventId/subscription',
        component: Subscription.SubscriptionIndex,
    },
    {
        exact: true,
        path: '/events/:eventId/subscription/speeddating',
        component: Subscription.SubscriptionSpeedDating,
    },
    {
        exact: true,
        path: '/events/:eventId/subscription/unlockschedule',
        component: Subscription.SubscriptionSchedule,
    },
    {
        exact: true,
        path: '/events/:eventId/subscription/success',
        component: Subscription.SubscriptionSuccess,
    },
    {
        exact: true,
        path: '/events/:eventId/subscription/payperuse',
        component: Subscription.SubscriptionPayPerUse,
    },
];

export const SubscriptionRoutes = props => (
    <Switch>
        {routes.map(r => {
            const Component = r.component || React.createComponent(r.toRender);
            const routeProp = { ...r, component: undefined };
            return <Route key={r.path} {...routeProp} render={() => <Component {...props} />} />;
        })}
    </Switch>
);
export default SubscriptionRoutes;
